<template>
	<div id="app">
		<style-loaders></style-loaders>
		<header>
			<span>
				<button @click="openMenu" class="menuButton" aria-label="apri menu">
					<i class="gdr-icon gdr-icon-bars"></i><span style="display:none !important">menu</span>
				</button>
				Gara di rutti
			</span>
		</header>
		<main>
			<menu-gdr :open="menuOpened"></menu-gdr>
			<router-view></router-view>
		</main>
		<div class="cookie-panel" v-if="!cookieOk">
			questo sito usa cookie
			<router-link to="/cookie-policy">
				Cookie Policy
			</router-link>
			<div class="btn-cookie-cont">
				<button @click="okCookie" class="btn-cookie">Accetto</button>
			</div>
		</div>
	</div>
</template>

<script>
import menuGdr from './components/menu'
import styleLoaders from './components/styleLoaders'

var mb="";

export default {
	name: 'app',
	components:{
		menuGdr,
		styleLoaders
	},
	props:{
		menuOpened:{
			default:false
		}
	},
	data (){
		return {
			menuOpenedA:false,
			cookieOk: false
		}
	},
	computed: {
		online: function(){
			if(navigator.onLine){
				return true
			}else{
				return false
			}
		}
	},
	methods:{
		openMenu: function(){
			if(this.menuOpened){
				this.$root.closeMenu()
			}else{
				this.$root.openMenu()
			}
			// this.$root.menuOpened = !this.$root.menuOpened;
		},
		closeMenu: function(){
			// this.$root.menuOpened = false;
		},
		okCookie: function(){
			this.cookieOk = true;
			this.$setItem("cookieOk", true, function(){
				console.log("cookie accepted");
			});
			return this.cookieOk;
		},
		checkCookieCheck: function(){
			var obj = this;
			this.$getItem("cookieOk", function(err, data){
				if(err){
					obj.cookieOk = false;
					return;
				}
				obj.cookieOk = data;
				return;
			});
		}
	},
	mounted: function(){
		this.checkCookieCheck();
		// alert("mounted started");
	}
}
</script>

<style lang="less">
body {
  margin: 0;
  height:100vh;
  width:100%;
  box-sizing: border-box;
  background-color: #eee;
  font-family: 'Open Sans', sans-serif;
  // background-color: green;
}

#app {
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // color: #2c3e50;
}

main {
  text-align: center;
  // margin-top: 40px;
}

header {
  margin: 0;
  height: 56px;
  padding: 0 16px 0 24px;
  background-color: #222;
  color: #ffffff;
  position:fixed;
  top:0;
  left: 0;
  width:100%;
  z-index:90;
  box-shadow: 0 3px 15px rgba(0,0,0,.65);
}

header span {
  display: block;
  position: relative;
  font-size: 20px;
  line-height: 1;
  letter-spacing: .02em;
  font-weight: 400;
  box-sizing: border-box;
  padding-top: 16px;
  font-family: 'Freckle Face', cursive;
}
.mainLayout{
	height:100vh;
	overflow-y: scroll;
	box-sizing: border-box;
	width:100%;
	padding-top:80px;
	padding-left:10px;
	padding-right:10px;
	@media(min-width:800px){
		padding-left:300px;
	}
}
.menuButton{
	display: inline-block;
	border: 0 !important;
	color: #FFF;
	background: none !important;
	@media(min-width:800px){
		display: none;
	}
}
.cookie-panel{
	position: fixed;
	bottom:0;
	width:100%;
	background-color:white;
	max-width: 250px;
	box-shadow: 0 3px 15px rgba(0, 0, 0, 0.31);
	padding:25px;
	z-index: 9999;
	a{
		display: inline-block;
	}
	.btn-cookie-cont{
		text-align:right;
		.btn-cookie{
			display:inline-block;
			background-color: black;
			color:white;
			line-height: 30px;
			padding:0;
			padding-left: 10px;
			padding-right: 10px;
			border: none;
			cursor: pointer;
		}
	}
}
</style>


// WEBPACK FOOTER //
// App.vue?62a88a18